<template>
    <Card>
      <AjaxForm route="admin/User/Add">
      <label class="mr-3">نوع کاربر : </label>
      <div class="form-check-inline my-1">
        <div class="custom-control custom-radio">
          <input type="radio" id="person_type" v-model="person_type" value="person" name="person_type" class="custom-control-input">
          <label class="custom-control-label" for="person_type">حقیقی</label>
        </div>
      </div>
      <div class="form-check-inline my-1">
        <div class="custom-control custom-radio">
          <input type="radio" id="company_type" name="person_type" value="company" v-model="person_type" class="custom-control-input">
          <label class="custom-control-label" for="company_type">حقوقی</label>
        </div>
      </div>
      <hr/>
      <div v-if="person_type === 'person'">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput type="text" v-model="user.phone" name="phone" placeholder="تلفن همراه..." label="تلفن همراه"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput type="text" v-model="user.f_name" label="نام" name="f_name" placeholder="نام"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput type="text" v-model="user.l_name" label="نام خانوادگی" name="l_name" placeholder="نام خانوادگی"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput type="text" label="کد ملی" v-model="user.national_code" name="national_code" placeholder="کد ملی..."></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput placeholder="صنف کاری را انتخاب کنید" label="صنف کاری" name="guild_id" select-label="title" :select-options="select_guild_option"
                         :fetch-options="getGuildsForSelect"
                         :select_multiple="true"
                         v-model="user.guild"
                         reduce_select="_id" type="select"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput type="date" label="تاریخ تولد" v-model="user.birthdate" name="birthdate" placeholder="تاریخ تولد..."></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput type="text" label="تلفن ثابت" v-model="user.telephone" name="telephone" placeholder="تلفن ثابت..."></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput type="email" label="ایمیل" v-model="user.email" name="email" placeholder="ایمیل..."></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput type="textarea" label="آدرس محل زندگی" v-model="user.address_house" name="address_house" placeholder="آدرس محل زندگی..."></CustomInput>
          </div>
        </div>
        <h5 class="font-weight-bold text-center">اطلاعات تجاری</h5>
        <div class="row">
          <div class="col-12 col-md-4">
            <CustomInput type="text" v-model="user.title" name="title" label="نام تجاری" placeholder="نام تجاری..."></CustomInput>
          </div>
          <div class="col-12 col-md-4">
            <CustomInput type="text" v-model="user.shop_telephone" name="shop_telephone" label="تلفن ثابت" placeholder="تلفن ثابت..."></CustomInput>
          </div>
          <div class="col-12 col-md-4">
            <CustomInput type="text" v-model="user.shop_telephone2" name="shop_telephone2" label="تلفن ثابت2" placeholder="تلفن ثابت..."></CustomInput>
          </div>
          <div class="col-12 col-md-4">
            <CustomInput type="text" v-model="user.shop_telephone3" name="shop_telephone3" label="تلفن ثابت3" placeholder="تلفن ثابت..."></CustomInput>
          </div>
          <div class="col-12 col-md-4">
            <CustomInput type="text" name="shop_phone" v-model="user.shop_phone" label="تلفن همراه" placeholder="تلفن همراه..."></CustomInput>
          </div>
          <div class="col-12 col-md-4">
            <CustomInput type="select" v-model="user.state" name="state_id" select-label="title" reduce_select="_id" :select-options="states" label="استان" placeholder="استان را انتخاب کنید..."></CustomInput>
          </div>
          <div class="col-12 col-md-4">
            <CustomInput type="select" v-model="user.city" select-label="title" reduce_select="_id"
                         :select-options="cities"
                         name="city_id" label="شهر" placeholder="شهر را انتخاب کنید..."></CustomInput>
          </div>
          <div class="col-12 col-md-4">
            <CustomInput type="textarea" v-model="user.shop_address" name="shop_address" label="آدرس" placeholder="آدرس..."></CustomInput>
          </div>
          <div class="col-12 col-md-4">
            <CustomInput type="textarea" v-model="user.shop_description" name="shop_description" label="درباره فروشگاه" placeholder="درباره فروشگاه..."></CustomInput>
          </div>
        </div>
        <h5 class="font-weight-bold text-center">تصاویر</h5>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-3">
            <DragDropFileUpload height="150" name="national_card_pic" title="کارت ملی"></DragDropFileUpload>
          </div>
          <div class="col-12 col-sm-12 col-md-3">
            <DragDropFileUpload height="150" name="back_national_card_pic" title="پشت کارت ملی"></DragDropFileUpload>
          </div>
          <div class="col-12 col-sm-12 col-md-3">
            <DragDropFileUpload height="150" name="javaz_kasb_pic" title="جواز کسب"></DragDropFileUpload>
          </div>
        </div>
      </div>
      <div v-if="person_type === 'company'">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput type="text" name="phone" v-model="user.phone" placeholder="تلفن همراه..." label="تلفن همراه"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput type="text"  v-model="user.company_title" label="نام شرکت" name="company_title" placeholder="نام شرکت"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput :required="true" label="مدیر عامل (نماینده حقوقی)" type="text" name="ceo_fullname" v-model="user.ceo_fullname" placeholder="نام مدیرعامل شرکت را وارد کنید"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput placeholder="صنف کاری را انتخاب کنید" label="صنف کاری" name="guild_id" select-label="title" :select-options="select_guild_option"
                         :fetch-options="getGuildsForSelect"
                         :select_multiple="true"
                         v-model="user.guild"
                         reduce_select="_id" type="select"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput type="text" v-model="user.national_id" name="national_id" label="شناسه ملی" placeholder="شناسه ملی..."></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput type="text" v-model="user.registration_number" name="registration_number" label="شماره ثبت" placeholder="شماره ثبت..."></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput type="text" v-model="user.economic_code" name="economic_code" label="کد اقتصادی" placeholder="کد اقتصادی..."></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput type="date" v-model="user.company_start_date" name="company_start_date" label="تاریخ تأسیس" placeholder="تاریخ تأسیس..."></CustomInput>
          </div>
          <div class="col-12 col-md-4">
            <CustomInput type="select" v-model="user.state" name="state_id" select-label="title" reduce_select="_id" :select-options="states" label="استان" placeholder="استان را انتخاب کنید..."></CustomInput>
          </div>
          <div class="col-12 col-md-4">
            <CustomInput type="select" v-model="user.city" select-label="title" reduce_select="_id"
                         :select-options="cities"
                         name="city_id" label="شهر" placeholder="شهر را انتخاب کنید..."></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput type="textarea" v-model="user.company_address" name="company_address" label="آدرس کامل شرکت" placeholder="آدرس کامل شرکت..."></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput type="email" name="email" v-model="user.email" label="ایمیل" placeholder="ایمیل..."></CustomInput>
          </div>
        </div>
        <h5 class="font-weight-bold text-center">اطلاعات تجاری</h5>
        <div class="row">
          <div class="col-12 col-md-4">
            <CustomInput type="text" name="title" v-model="user.title" label="نام تجاری" placeholder="نام تجاری..."></CustomInput>
          </div>
          <div class="col-12 col-md-4">
            <CustomInput type="text" name="shop_telephone" v-model="user.shop_telephone" label="تلفن ثابت" placeholder="تلفن ثابت..."></CustomInput>
          </div>
          <div class="col-12 col-md-4">
            <CustomInput type="text" name="shop_phone" v-model="user.shop_phone" label="تلفن همراه" placeholder="تلفن همراه..."></CustomInput>
          </div>
          <div class="col-12 col-md-4">
            <CustomInput type="textarea" v-model="user.shop_description"  name="shop_description" label="درباره فروشگاه" placeholder="درباره فروشگاه..."></CustomInput>
          </div>
        </div>
        <h5 class="font-weight-bold text-center">تصاویر</h5>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-3">
            <DragDropFileUpload height="150" name="agahi_tasis_pic" title="آگهی تاسیس"></DragDropFileUpload>
          </div>
          <div class="col-12 col-sm-12 col-md-3">
            <DragDropFileUpload height="150" name="asasname_pic" title="اساس نامه"></DragDropFileUpload>
          </div>
          <div class="col-12 col-sm-12 col-md-3">
            <DragDropFileUpload height="150" name="newspaper_pic" title="روزنامه"></DragDropFileUpload>
          </div>
          <div class="col-12 col-sm-12 col-md-3">
            <DragDropFileUpload height="150" name="last_change_pic" title="آخرین تغییرات"></DragDropFileUpload>
          </div>
          <div class="col-12 col-sm-12 col-md-3">
            <DragDropFileUpload height="150" name="javaz_kasb_pic" title="جواز کسب"></DragDropFileUpload>
          </div>
        </div>
      </div>
      <hr/>
      <div class="row">
        <div class="col-12 col-sm-4">
          <CustomInput v-model="user.customer_status" type="select" name="status" select-label="title" reduce_select="value" :select-options="status_options" label="وضعیت" placeholder="وضعیت را انتخاب کنید"></CustomInput>
        </div>
        <div class="col-12 col-sm-4">
          <CustomInput type="text" v-model="user.refferal_code" name="refferal_code" placeholder="کد معرف اختیاری" label="کد معرف"></CustomInput>
        </div>
        <div v-if="user.status && user.status.value === 'denied'">
          <CustomInput type="textarea" v-model="user.deny_reason" name="deny_reason" label="دلیل رد کردن" placeholder="دلیل رد کردن..."></CustomInput>
        </div>
      </div>
      <div class="row">
        <div class="col-10 col-sm-8 col-md-5 mx-auto mt-3">
          <button class="btn btn-info btn-block" type="submit">ذخیره اطلاعات کاربر</button>
        </div>
      </div>
      </AjaxForm>
    </Card>
</template>

<script>
import MasterLayout from "@/components/MasterLayout";
import Card from "@/components/forms/Card";
import CustomInput from "@/components/CustomInput";
import DragDropFileUpload from "@/components/DragDropFileUpload";
import {AppApi} from "@/api/AppApi";
import {ProductApi} from "@/api/ProductApi";
import AjaxForm from "@/components/forms/AjaxForm";
import {mapActions, mapGetters} from "vuex";
import {sleep} from "@/shared/helper";
export default {
name: "UserAdd",
  components:{AjaxForm, DragDropFileUpload, CustomInput, Card, MasterLayout},
  data()
  {
    return{
      person_type : 'person',
      user:{},
      states:[],
      cities : [],
      select_guild_option : [],
      guild:[],
      status:null,
      status_options:[{value : 'waiting',title : 'در انتظار بررسی'},{value : 'confirmed',title : 'تایید شده'},{value : 'denied',title : 'رد شده'}]
    }
  },
  async mounted()
  {
    this.setPageTitle('افزودن کاربر جدید');
    this.setShowHead(true);
    const self = this;
     AppApi.getStates().then(result=>{
       self.states = result;
    });
  },
  methods:{
    ...mapActions('app',{
      setPageTitle:'setPageTitle',
      setPageLoading:'setPageLoading',
      setShowHead : 'setShowHead'
    }),
    getCitiesByStateId()
    {
      AppApi.getCitiesByStateId(this.user.state_id).then(result=>{
        this.cities = result;
      })
    },
    async getGuildsForSelect(search,loading)
    {
      loading(true);
      if (search.length > 1)
      {
        const data = await ProductApi.getGuildForSelectAjax(search);
        if (data.ok)
        {
          this.select_guild_option = data.guilds;
        }
        else
          this.select_guild_option = [];
      }
      loading(false);
    },
  },
  watch:{
    'user.state':{
    handler(s)
    {
      if (s)
      {
        this.user.state_id = s._id;
        this.getCitiesByStateId();
      }
      else
      {
        this.user.state_id = null;
        this.cities = [];
      }
      this.user.city = null;
      this.user.city_id = null;
    }
  }
  },
}
</script>

<style scoped>

</style>